import * as _ from 'underscore';
import { Selectable } from './selectable';
import { IClickable, IEvent } from '../../interfaces';
import { Event } from '../event';
import { SelectClickableOptions } from '../../interfaces/options';

export class SelectClickable extends Selectable implements IClickable {
	public click: () => void;
	public toggle: () => void;
	private onSelect: Event<boolean>;
	public get Selected(): IEvent<boolean> {
		return this.onSelect;
	}
	//TODO delete old callBack concept - move to Event<T>
	private callBack: (isSelected: boolean) => any;
	constructor(options: SelectClickableOptions) {
		super(options);
		this.initSelectClickable(options);
	}
	public initSelectClickable(options: SelectClickableOptions) {
		this.onSelect = new Event<boolean>();
		this.callBack = options.callBack;
		this.click = () => {
			this.setSelected(true);
			if (_.isFunction(this.callBack)) {
				this.callBack(this.isSelected());
			}
			this.onSelect.notify(this.isSelected());
		};
		this.toggle = () => {
			this.set(!this.isSelected());
			this.onSelect.notify(this.isSelected());
		};
	}
	public set(isSelected: boolean) {
		super.setSelected(isSelected);
		if (_.isFunction(this.callBack)) {
			this.callBack(this.isSelected());
		}
		this.onSelect.notify(this.isSelected());
	}
	public clear() {}
}
